import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FORM_FIELDS } from "../../Constants";
import Tooltip from "../../../Common/Tooltip";
import { address, numbersOnly, storeTag } from "../../../../Config/Regex";
import ErrorMessage from "../../components/ErrorMessage";
import PriceListTable from "./PriceListTable";
import PosTable from "./PosTable";
import Select from "react-select";
import { globalServices } from "../../../../Services";

const AddStoreModal = ({
  show,
  onHide,
  postOffices,
  setStores,
  stores,
  updateData,
}) => {
  const { STORE_DATA } = FORM_FIELDS;

  const [posData, setPosData] = useState([]);

  // const [priceListFormData, setPriceListFormData] = useState([]);
  // const [priceListTableData, setPriceListTableData] = useState([]);
  // const [priceListInvalidRows, setPriceListInvalidRows] = useState({});

  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    if (!updateData) return;
    Object.keys(updateData).forEach((x) => {
      setValue(x, updateData[x]);
    });
    if (updateData[STORE_DATA.POS_DATA.name]) {
      setPosData(updateData[STORE_DATA.POS_DATA.name]);
    }
    // if (updateData[STORE_DATA.PRICE_LIST_DATA.name]) {
    //   setPriceListFormData(updateData[STORE_DATA.PRICE_LIST_DATA.name]);
    // }
    // if (updateData.priceListTableData) {
    //   setPriceListTableData(updateData.priceListTableData);
    // }
  }, [updateData]);

  const resetState = () => {
    setPosData([]);
    // setPriceListFormData([]);
    // setPriceListTableData([]);
    // setPriceListInvalidRows({});
  };

  const handleAddNewStore = (data) => {
    setStores((stores) => [
      ...stores,
      {
        ...data,
        posData,
        // priceListTableData,
        // priceListData: priceListFormData,
      },
    ]);
  };

  const handleUpdateStore = (data) => {
    setStores((stores) => {
      const index = stores.findIndex((item) => item.tag === updateData.tag);
      const newStores = [...stores];
      newStores[index] = {
        ...data,
        posData,
        // priceListTableData,
        // priceListData: priceListFormData,
      };
      return newStores;
    });
  };

  const onSubmit = (data) => {
    if (!updateData) handleAddNewStore(data);
    if (updateData) handleUpdateStore(data);
    onHide();
    resetState();
  };

  const setCity = (id) => {
    globalServices.getCityByPostOffice(id).then((res) => {
      setValue(STORE_DATA.CITY.name, res?.data?.data?.name, {
        shouldValidate: true,
      });
    });
  };

  return (
    <Modal
      centered
      show={show}
      onHide={onHide}
      size="lg"
      className="public-onboarding__add-store-modal"
    >
      <Modal.Header>
        {updateData ? "Uredi prodajno mjesto" : "Dodaj prodajno mjesto"}
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-lg-6">
            <fieldset className="scheduler-border">
              <div className="form-group">
                <label>{STORE_DATA.DESCRIPTION.title}</label>{" "}
                <Tooltip
                  text={
                    "Naziv prodajnog mjesta koji će se ispisivati na zaglavlju računa."
                  }
                />
                <input
                  type="text"
                  className="form-control"
                  name={STORE_DATA.DESCRIPTION.name}
                  ref={register({ required: true, maxLength: 100 })}
                />
                <ErrorMessage
                  errorType={errors?.[STORE_DATA.DESCRIPTION.name]?.type}
                  messages={{
                    required: "Ovo polje je obavezno!",
                    maxLength: "Moguće je unijeti maksimalno 100 znakova!",
                  }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="tag">{STORE_DATA.TAG.title}</label>{" "}
                <Tooltip
                  text={
                    "Jedinstvena oznaka koja se dobije putem sustava e-porezna, dio je broja svakog izdanog računa. Ovaj podatak nalazi se u Internom aktu, nije ga dozvoljeno naknadno mijenjati, ako nije unesen fiskalizacija računa se neće izvršiti. Dopušten je unos do 20 znakova, kombinacija velikih i malih slova. Ako još nemate interni akt oznaku prodajnog mjesta navedite kao i ovdje. "
                  }
                />
                <input
                  type="text"
                  className="form-control"
                  name={STORE_DATA.TAG.name}
                  ref={register({
                    required: true,
                    pattern: storeTag,
                    validate: (data) => {
                      if (data === updateData?.[STORE_DATA.TAG.name]) {
                        return true;
                      }
                      if (
                        stores.some(
                          (store) => store[STORE_DATA.TAG.name] === data
                        )
                      ) {
                        return false;
                      }
                      return true;
                    },
                  })}
                />
                <ErrorMessage
                  errorType={errors?.[STORE_DATA.TAG.name]?.type}
                  messages={{
                    validate: "Već postoji prodajno mjesto za istom oznakom.",
                    required: "Ovo polje je obavezno!",
                    pattern:
                      "Oznaka prodajnog mjesta može sadržavati maksimalno 20 znakova. Nije dopušten unos dijakritičkih znakova.",
                  }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="type">{STORE_DATA.TYPE.title}</label>
                <select
                  className="form-control"
                  name={STORE_DATA.TYPE.name}
                  ref={register({ required: true })}
                  //   defaultValue={createStoreData.type}
                >
                  <option value="" disabled>
                    Odaberite tip prodajnog mjesta
                  </option>
                  <option value="1">Fiksno</option>
                  <option value="2">Mobilno</option>
                </select>
                <ErrorMessage
                  errorType={errors?.[STORE_DATA.TYPE.name]?.type}
                  messages={{
                    required: "Ovo polje je obavezno!",
                  }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="footerNote">
                  {STORE_DATA.FOOTER_NOTE.title}
                </label>{" "}
                <Tooltip
                  text={
                    "Ako želite da se ispisuje dodatni tekst u podnožju računa upućen vašim kupcima upišite željeni tekst. Npr. Wifi lozinku ili Hvala na posjeti i sl. "
                  }
                />
                <input
                  type="text"
                  className="form-control"
                  name={STORE_DATA.FOOTER_NOTE.name}
                  ref={register({ required: true, maxLength: 250 })}
                />
                <ErrorMessage
                  errorType={errors?.[STORE_DATA.FOOTER_NOTE.name]?.type}
                  messages={{
                    required: "Ovo polje je obavezno!",
                    maxLength: "Moguće je unijeti maksimalno 250 znakova!",
                  }}
                />
              </div>
            </fieldset>
          </div>
          <div className="col-lg-6">
            <fieldset className="scheduler-border">
              <div className="form-container">
                <div className="form-group">
                  <label htmlFor="storeStreet">{STORE_DATA.STREET.title}</label>{" "}
                  <Tooltip
                    text={
                      "Puni naziv registrirane adrese sjedišta tvrtke ili obrta, mjesto na kojem se prodajno mjesto nalazi. "
                    }
                  />
                  <input
                    type="text"
                    className="form-control"
                    name={STORE_DATA.STREET.name}
                    ref={register({
                      required: true,
                      maxLength: 150,
                      pattern: address,
                    })}
                  />
                  <ErrorMessage
                    errorType={errors?.[STORE_DATA.STREET.name]?.type}
                    messages={{
                      required: "Ovo polje je obavezno!",
                      maxLength: "Moguće je unijeti maksimalno 150 znakova!",
                      pattern:
                        "Dopušten je samo tekstualni unos, brojevi i točka!",
                    }}
                  />
                </div>
                <div className="form-row m-0">
                  <div className="form-group col-md-8 m-0">
                    <label htmlFor="streetNumber">
                      {STORE_DATA.STREET_NUMBER.title}
                    </label>{" "}
                    <Tooltip
                      text={
                        "Kućni broj koji se određuje u svrhu lociranja zgrade u prostoru, te evidentiranja zgrade u adresnom sustavu. Kućni broj treba biti isključivo brojčana vrijednost. Ako imate oznaku 'bez broja' u kućni broj možete upisati približnu vrijednost ili vrijednost 0, a 'bb' potom upisati u polje Dodatak. Ako kućni broj ima kombinaciju brojki i slova npr. 38A, u polje Kućni broj unesite samo brojku (npr. 38), a u polje Dodatak unesite slovo (npr. A)."
                      }
                    />
                    <input
                      type="text"
                      className="form-control"
                      name={STORE_DATA.STREET_NUMBER.name}
                      ref={register({
                        required: true,
                        pattern: numbersOnly,
                        maxLength: 6,
                      })}
                    />
                    <ErrorMessage
                      errorType={errors?.[STORE_DATA.STREET_NUMBER.name]?.type}
                      messages={{
                        required: "Ovo polje je obavezno!",
                        maxLength: "Moguće je unijeti maksimalno 6 znakova!",
                        pattern: "Dopušten je samo unos brojeva",
                      }}
                    />
                  </div>
                  <div className="form-group col-md-4 m-0">
                    <label htmlFor="storeStreetNumberExtension">
                      {STORE_DATA.STREET_NUMBER_EXTENSTION.title}
                    </label>{" "}
                    <Tooltip
                      text={
                        "Ako kućni broj ima dodatak, npr. Naziv ulice 38 A ili ako nema kućnog broja unosi se 'bb' (bez broja)."
                      }
                    />
                    <input
                      type="text"
                      className="form-control"
                      name={STORE_DATA.STREET_NUMBER_EXTENSTION.name}
                      ref={register({ maxLength: 10 })}
                    />
                    <ErrorMessage
                      errorType={errors?.[STORE_DATA.STREET_NUMBER.name]?.type}
                      messages={{
                        maxLength: "Moguće je unijeti maksimalno 10 znakova!",
                      }}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="storePostalNumber">
                    {STORE_DATA.POSTAL_NUMBER.title}
                  </label>{" "}
                  <Tooltip
                    text={
                      "Odabir poštanskog broja za pripadajući grad, kombinacija brojeva kako bi se omogućilo brzo strojno razvrstavanje pošiljki."
                    }
                  />
                  <Controller
                    as={Select}
                    options={(postOffices?.data || []).map((x) => ({
                      id: x.id,
                      label: x.name,
                      value: x.name,
                    }))}
                    name={STORE_DATA.POSTAL_NUMBER.name}
                    control={control}
                    ref={register({
                      required: true,
                    })}
                    onChange={function (event) {
                      setCity(event[0].id);
                      return event[0];
                    }}
                  />
                  <ErrorMessage
                    errorType={errors?.[STORE_DATA.POSTAL_NUMBER.name]?.type}
                    messages={{
                      required: "Ovo polje je obavezno!",
                    }}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="storeCity">{STORE_DATA.CITY.title}</label>{" "}
                  <Tooltip text={"StoreDataCity-Msg"} />
                  <input
                    type="text"
                    className="form-control"
                    name={STORE_DATA.CITY.name}
                    ref={register({ required: true })}
                  />
                  <ErrorMessage
                    errorType={errors?.[STORE_DATA.CITY.name]?.type}
                    messages={{
                      required: "Ovo polje je obavezno!",
                    }}
                  />
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-lg-12">
            <hr></hr>
            <PosTable data={posData} setData={setPosData} />
            <input
              type="hidden"
              name={STORE_DATA.POS_DATA.name}
              ref={register({
                validate: (data) => {
                  return JSON.parse(data)?.length >= 1;
                },
              })}
              value={JSON.stringify(posData)}
            />
            <ErrorMessage
              errorType={errors?.[STORE_DATA.POS_DATA.name]?.type}
              messages={{
                validate: "Morate unijeti barem jednu blagajnu",
              }}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end">
          <Button onClick={handleSubmit(onSubmit)}>
            {updateData ? "Uredi" : "Dodaj"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddStoreModal;
